import { Outlet } from "react-router";
import Sidebar from "./Sidebar";

const Layout = () => {
  return (
    <div>
      <Sidebar />
      <div className="layoutmain">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
